import React, { useMemo } from 'react';
import { styled } from '@mui/material/styles';
import { t } from '../constants/translationHelper';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { Link as RouterLink } from 'react-router-dom';
import InsertDriveFileIcon from '@mui/icons-material/AssignmentLateOutlined';
import DirectionsBoatOutlinedIcon from '@mui/icons-material/DirectionsBoatOutlined';
import SummarizeOutlinedIcon from '@mui/icons-material/SummarizeOutlined';
import DateRangeOutlinedIcon from '@mui/icons-material/DateRangeOutlined';
import BatchPredictionOutlinedIcon from '@mui/icons-material/BatchPredictionOutlined';
import RocketLaunchOutlinedIcon from '@mui/icons-material/RocketLaunchOutlined';
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';
import AutoStoriesOutlinedIcon from '@mui/icons-material/AutoStoriesOutlined';
import PaymentOutlinedIcon from '@mui/icons-material/PaymentOutlined';
import ReceiptOutlinedIcon from '@mui/icons-material/ReceiptOutlined';
import ProductionQuantityLimitsOutlinedIcon from '@mui/icons-material/ProductionQuantityLimitsOutlined';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import AttachMoneyOutlinedIcon from '@mui/icons-material/AttachMoneyOutlined';
import CardGiftcardOutlinedIcon from '@mui/icons-material/CardGiftcardOutlined';

const ContentWrapper = styled('section')(({ theme }) => ({
    padding: theme.spacing(0),
}));

const CustomCard = styled(Card)(({ theme }) => ({
    minHeight: '325px',
    maxHeight: '400px',
    transition: 'transform 0.2s, box-shadow 0.2s',
    '&:hover': {
        transform: 'scale(1.05)',
        boxShadow: theme.shadows[1],
    },
}));

const CardBody = styled(CardContent)(({ theme }) => ({
    padding: theme.spacing(3),
}));

const Heading = styled(Typography)(({ theme }) => ({
    fontWeight: 600,
}));

const CustomLink = styled(RouterLink)(({ theme }) => ({
    display: 'flex',
    fontSize: "12px",
    textTransform: "capitalize",
    fontWeight: 600,
    alignItems: 'center',
    color: theme.palette.text.primary,
    textDecoration: 'none',
    marginTop: theme.spacing(1),
    transition: 'color 0.2s',
    '&:hover': {
        color: '#0652DD',
        textDecoration: 'underline',
    },
}));


const cards = [
    {
        title: 'Import Shipment',
        links: [
            { to: '/app/reports/importshipmentreport', icon: <DirectionsBoatOutlinedIcon />, text: 'Import Shipment Report' },
            { to: '/app/reports/freedaysreport', icon: <SummarizeOutlinedIcon />, text: 'Free Days Report' },
            { to: '/app/reports/batchnowiseimportshipmentreport', icon: <BatchPredictionOutlinedIcon />, text: 'Batch no. wise Imp. shipment Report' },
            { to: '/app/reports/duedateimportshipmentreport', icon: <DateRangeOutlinedIcon />, text: 'due date report' },
            { to: '/app/reports/importbudgetplanningreport', icon: <SummarizeOutlinedIcon />, text: 'budget planning' },
        ],
    },
    {
        title: 'Export Shipment',
        links: [
            { to: '/app/reports/exportshipmentreport', icon: <RocketLaunchOutlinedIcon />, text: 'Export Shipment Report' },
            { to: '/app/reports/proforminvreport', icon: <InsertDriveFileOutlinedIcon />, text: 'Proform Inv. Report' },
            { to: '/app/reports/salescontractreport', icon: <InsertDriveFileOutlinedIcon />, text: 'Sales Contract Report' },
            { to: '/app/reports/commercialinvoiceregister', icon: <InsertDriveFileOutlinedIcon />, text: 'Commercial Invoice Register' },
            { to: '/app/reports/batchnowiseexportshipmentreport', icon: <BatchPredictionOutlinedIcon />, text: 'Batch no. wise Exp. shipment Report' },
            { to: '/app/reports/duedateexportshipmentreport', icon: <DateRangeOutlinedIcon />, text: 'due date report' },
            { to: '/app/reports/exportbudgetplanningreport', icon: <SummarizeOutlinedIcon />, text: 'budget planning' },

        ],
    },
    {
        title: 'Ledger',
        links: [
            { to: '/app/reports/customerledger', icon: <AutoStoriesOutlinedIcon />, text: 'Customer Ledger' },
            { to: '/app/reports/supplierledger', icon: <AutoStoriesOutlinedIcon />, text: 'Supplier Ledger' },
            { to: '/app/reports/expensePartyLedgerReport', icon: <AutoStoriesOutlinedIcon />, text: 'Expense Party Ledger' },
        ],
    },
    {
        title: 'Payment Register',
        links: [
            { to: '/app/reports/paymentregister', icon: <PaymentOutlinedIcon />, text: 'Payment Register' },
            { to: '/app/reports/receiptregister', icon: <ReceiptOutlinedIcon />, text: 'Receipt Register' },
            { to: '/app/reports/importpaymentreport', icon: <PaymentOutlinedIcon />, text: 'Import payment Report' },
            { to: '/app/reports/exportpaymentreport', icon: <ReceiptOutlinedIcon />, text: 'Export payment Report' },
        ],
    },
    {
        title: 'Costing',
        links: [
            // { to: '/app/reports/shipmentcostingreport', icon: <InsertDriveFileIcon />, text: 'Shipment Costing Report' },
            { to: '/app/reports/importshipmentcostingreport', icon: <AttachMoneyOutlinedIcon />, text: 'Import shipment costing Report' },
            { to: '/app/reports/exportshipmentcostingreport', icon: <AttachMoneyOutlinedIcon />, text: 'Export shipment costing Report' },
        ],
    },
    {
        title: 'Tracking',
        links: [
            { to: '/app/reports/importshipmenttracking', icon: <LocationOnOutlinedIcon />, text: 'Import Shipment Tracking' },
            { to: '/app/reports/exportshipmenttracking', icon: <LocationOnOutlinedIcon />, text: 'Export Shipment Tracking' },
        ],
    },


    {
        title: 'Report',
        links: [
            { to: '/app/reports/importbookingreport', icon: <CardGiftcardOutlinedIcon />, text: 'Import Booking Report' },
            { to: '/app/reports/exportbookingreport', icon: <CardGiftcardOutlinedIcon />, text: 'Export Booking Report' },
            { to: '/app/reports/productwiseimportreport', icon: <ProductionQuantityLimitsOutlinedIcon />, text: 'Product wise import Report' },
            { to: '/app/reports/productwiseexportreport', icon: <ProductionQuantityLimitsOutlinedIcon />, text: 'Product wise export Report' },

            { to: '/app/reports/customerproduct', icon: <ProductionQuantityLimitsOutlinedIcon />, text: 'Customer wise Product' },
            { to: '/app/reports/supplierproduct', icon: <ProductionQuantityLimitsOutlinedIcon />, text: 'Supplier wise Product' },

            { to: '/app/reports/importproductgroupreport', icon: <ProductionQuantityLimitsOutlinedIcon />, text: 'Import Product Group Report' },
            { to: '/app/reports/exportproductgroupreport', icon: <ProductionQuantityLimitsOutlinedIcon />, text: 'Export Product Group Report' },
        ],
    }
];
const cardsAlexxcansols = [
    {
        title: 'Report',
        links: [
            { to: '/alexxcansols/reports/partnerlistreport', icon: <SummarizeOutlinedIcon />, text: 'Partner List' },
            { to: '/alexxcansols/reports/deleteduserrecords', icon: <SummarizeOutlinedIcon />, text: 'Subscription Grace Report' },
            { to: '/alexxcansols/reports/deletedatabaselog', icon: <SummarizeOutlinedIcon />, text: 'Delete Databasel Log' },
        ],
    },

];
const cardsPartner = [
    {
        title: 'Report',
        links: [
            { to: '/partner/reports/deleteduserrecords', icon: <SummarizeOutlinedIcon />, text: 'Subscription Grace Report' },
        ],
    },

];

const ResponsiveCards = () => {
    // 🔹 Get businessProfile from sessionStorage
    const businessProfile = useMemo(() => {
        try {
            const userDataString = sessionStorage.getItem("userData");
            if (!userDataString) return null;

            const userData = JSON.parse(userDataString);
            return userData?.authUser?.businessProfile || null;
        } catch (error) {
            console.error("Invalid userData in sessionStorage:", error);
            return null;
        }
    }, []);

    // 🔹 Decide which cards to render
    const cardsToRender = useMemo(() => {
        if (businessProfile === "owner") {
            return cardsAlexxcansols;
        }
        if (businessProfile === "partner") {
            return cardsPartner;
        }
        return cards; // default
    }, [businessProfile]);

    return (
        <div>
            <ContentWrapper style={{ marginTop: '0px' }} variant="outlined">
                <CardContent>
                    <Heading variant="h4" style={{ paddingBottom: '10px' }}>
                        {t("Reports")}
                    </Heading>
                    <Grid container spacing={2}>
                        {cardsToRender.map((card, index) => (
                            <Grid item key={index} xs={12} sm={6} md={3}>
                                <CustomCard variant="outlined">
                                    <CardBody>
                                        <Heading variant="h4">{t(card.title)}</Heading>
                                        {card.links.map((link, linkIndex) => (
                                            <Typography key={linkIndex} variant="body2">
                                                <CustomLink to={link.to}>
                                                    <span style={{ fontSize: "15px", marginTop: "2px", textTransform: "capitalize" }}> {link.icon}  </span> &nbsp; {t(link.text)}
                                                </CustomLink>
                                            </Typography>
                                        ))}
                                    </CardBody>
                                    <br />
                                </CustomCard>
                            </Grid>
                        ))}
                    </Grid>
                </CardContent>
            </ContentWrapper>
        </div>
    );
};

export default ResponsiveCards;
